import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Moeda',
        path: '/biblioteca/bibmoeda',
        name: 'bibmoeda',
        component: () => import('@/views/biblioteca/bibmoeda/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_MOEDANOVO_MENU_1300801199],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Moeda',
        path: '/biblioteca/bibmoeda/cadastro/:id?',
        parent: 'bibmoeda',
        name: 'bibmoeda_create',
        component: () => import('@/views/biblioteca/bibmoeda/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_MOEDANOVO_MENU_1300801199],
        },
        goesToMenu: true,
    },
]
